import React, { useReducer, useEffect, useContext, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { BreadcrumbContext } from "../../../contexts/BreadcrumbContext";
import axios from "../../../config/axios";
import BlockErrorMessage from "../../UI/errorMessages/BlockErrorMessage";
import DashboardLayout from "../../UI/layouts/DashboardLayout";
import ModuleHeader from "../../UI/modules/views/partials/common/ModuleHeader";
import moduleConfig from "./moduleConfig";
import {
  detailsReducer,
  memberDetailsInitialState,
} from "./reducers/detailsReducer";
import Details from "./partials/details/Details";
import { Col, Row } from "react-bootstrap";
import { OverlayLoading } from "../../UI/loading/OverlayLoading";
import PollQuestionsListing from "./partials/details/PollQuestionsListing";
import { Store as toast } from "react-notifications-component";
import { toastNotification } from "../../../config/toastNotification";
import useConfirm from "../../../HOC/custom/useConfirm";
import ChangeStatusModal from "./partials/details/ChangeStatusModal";

let breadcrumbs = {
  listing: {
    label: moduleConfig.title,
    url: `/${moduleConfig.url}`,
  },
  details: {
    label: "Details",
  },
};

const PollView = () => {
  const { setBreadcrumb } = useContext(BreadcrumbContext);
  const [detailsState, detailsDispatch] = useReducer(
    detailsReducer,
    memberDetailsInitialState
  );
  const [showChangeStatusModal, setShowChangeStatusModal] =
    useState(false);

  let { id } = useParams();
  const { confirm } = useConfirm();

  const confirmAndStop = async (id) => {
    const isConfirmed = await confirm(
      `Do you really want to stop the submission for this poll?`
    );

    if (isConfirmed) {
      await changeStatus(id, "finished");
    }
  };
  const confirmAndAnnounce = async (id) => {
    const isConfirmed = await confirm(
      `Do you really want to announce the results for this poll?`
    );

    if (isConfirmed) {
      await changeAnnouncedStatus(id, "1");
    }
  };
  const confirmAndHide = async (id) => {
    const isConfirmed = await confirm(
      `Do you really want to hide the results for this poll?`
    );

    if (isConfirmed) {
      await changeAnnouncedStatus(id, "0");
    }
  };
  const confirmAndStart = async (id) => {
    const isConfirmed = await confirm(
      `Do you really want to start the submission for this poll?`
    );

    if (isConfirmed) {
      await changeStatus(id, "begun");
    }
  };

  const changeStatus = async (id, status) => {
    console.log("In block Item Function");
    detailsDispatch({
      type: "FETCH_REQUEST",
    });

    try {
      const res = await axios.post(`${moduleConfig.url}/change-status`, {
        id,
        status,
      });
      loadItem();
      toast.addNotification({
        ...toastNotification,
        title: "Success!",
        message: `Poll submission is ${status === "begun" ? "started" : "finished"} successfully.`,
        type: "success",
      });
    } catch (error) {
      detailsDispatch({
        type: "FETCH_FAILURE",
        payload: error,
      });

      setTimeout(() => {
        detailsDispatch({
          type: "REMOVE_ERROR",
        });
      }, 5000);
    }
  };
  const changeAnnouncedStatus = async (id, status) => {
    console.log("In block Item Function");
    detailsDispatch({
      type: "FETCH_REQUEST",
    });

    try {
      const res = await axios.post(`${moduleConfig.url}/change-announced-status`, {
        id,
        status,
      });
      await loadItem();
      toast.addNotification({
        ...toastNotification,
        title: "Success!",
        message: `Poll results announced successfully.`,
        type: "success",
      });
    } catch (error) {
      detailsDispatch({
        type: "FETCH_FAILURE",
        payload: error,
      });

      setTimeout(() => {
        detailsDispatch({
          type: "REMOVE_ERROR",
        });
      }, 5000);
    }
  };

  const loadItem = async () => {
    if (id) {
      detailsDispatch({
        type: "FETCH_REQUEST",
      });
      try {
        const res = await axios.get(`${moduleConfig.url}/${id}`); //
        detailsDispatch({
          type: "FETCH_SUCCESS",
          payload: res.data,
        });
      } catch (error) {
        detailsDispatch({
          type: "FETCH_FAILURE",
          payload: error,
        });
      }
    }
  };
  useEffect(() => {
    loadItem();
    setBreadcrumb([breadcrumbs.listing, breadcrumbs.details]);
  }, [id]);



  return (
    <DashboardLayout>
      {detailsState.isFetching && <OverlayLoading />}
      {detailsState.data.item && !detailsState.isFetching && (
        <>
          {detailsState.hasError ? (
            <BlockErrorMessage error={detailsState.error} />
          ) : (
            <>
              {detailsState.data.item && (
                <>
                  <ModuleHeader
                    moduleTitle={`View ${moduleConfig.singleItemTitle}`}
                    moduleUrl={moduleConfig.url}
                  ></ModuleHeader>

                  <div className="border d-flex mb-1 p-1 bg-light text-white rounded">
                    <Link
                      title="Update Item"
                      to={`/${moduleConfig.url}/update/${detailsState.data.item._id}`}
                      className="btn btn-primary  border me-1"
                    >
                      <i className="fas fa-pencil-alt text-white me-1"></i>{" "}
                      <span className="text-white">Update</span>
                    </Link>
                    {detailsState.data.item.target === "Selected-Members" && (
                      <Link
                        title="Manage Targeted Members"
                        to={`/${moduleConfig.url}/manage-members/${detailsState.data.item._id}`}
                        className="btn btn-primary  border me-1"
                      >
                        <i className="fas fa-users text-white me-1"></i>{" "}
                        <span className="text-white">
                          Manage Targeted Members
                        </span>
                      </Link>
                    )}

                    {detailsState.data.item.target === "Selected-Circles" && (
                      <Link
                        title="Manage Targeted Circles"
                        to={`/${moduleConfig.url}/manage-circles/${detailsState.data.item._id}`}
                        className="btn btn-primary  border me-1"
                      >
                        <i className="fas fa-users text-white me-1"></i>{" "}
                        <span className="text-white">
                          Manage Targeted Circles
                        </span>
                      </Link>
                    )}


                    <Link
                      title="Change Status"
                      onClick={() =>
                        setShowChangeStatusModal(true)
                      }
                      className="btn btn-primary  border me-1"
                    >
                      <i className="fas fa-exclamation-circle text-white me-1"></i>{" "}
                      <span className="text-white">
                        Change Status
                      </span>
                    </Link>
                    {/* {detailsState.data.item.resultType === "After Finishing" && detailsState.data.item.isAnnounced === "0" &&
                      <Link
                        title="Announce Result"
                        onClick={() =>
                          confirmAndAnnounce(detailsState.data.item._id)
                        }
                        className="btn btn-primary  border me-1"
                      >
                        <i className="fas fa-trophy text-white me-1"></i>{" "}
                        <span className="text-white">
                          Announce Result
                        </span>
                      </Link>}
                    {detailsState.data.item.resultType === "After Finishing" &&  detailsState.data.item.isAnnounced === "1" &&
                      <Link
                        title="Announce Result"
                        onClick={() =>
                          confirmAndHide(detailsState.data.item._id)
                        }
                        className="btn btn-secondary  border me-1"
                      >
                        <i className="fas fa-trophy text-white me-1"></i>{" "}
                        <span className="text-white">
                          Hide Result
                        </span>
                      </Link>} */}
                  </div>

                  <Details
                    item={detailsState.data.item}
                    moduleConfig={moduleConfig}
                    confirmAndStop={confirmAndStop}
                    confirmAndStart={confirmAndStart}
                  />


                  <Row>
                    <Col xs={12} sm={12} md={12} lg={12}>
                      <PollQuestionsListing
                        pollId={detailsState.data.item._id}
                      />
                    </Col>
                  </Row>

                  <ChangeStatusModal
                    pollId={detailsState.data.item._id}
                    initialValue={detailsState.data.item.status}
                    show={showChangeStatusModal}
                    setShow={setShowChangeStatusModal}
                    loadItem={loadItem}
                  />
                </>
              )}
            </>
          )}
        </>
      )}
    </DashboardLayout>
  );
};

export default PollView;
